import { useState } from "react";

const FAQS = [
  ["We already have a data protection officer. Why an AI officer?", "A DPO looks after personal data. An AI officer looks after how your company uses AI: which tools, on what basis, with what documentation, and what the AI Act requires of each. The two roles work together, and we align everything we do with your privacy set-up."],
  ["Is this legal advice?", "The licence covers governance, tool implementation, training and monitoring. Where a matter needs formal legal advice or representation, it is handled by qualified counsel under a separate engagement, and we tell you before that line is crossed."],
  ["We're a US or UK company selling into the EU. Does this apply to us?", "Usually, yes. The AI Act applies when your AI system is placed on the EU market or its output is used in the EU, wherever you are based. Non-EU providers of high-risk AI must also appoint an EU representative. The Partner licence includes that mandate, so your buyers and regulators have one European contact."],
  ["Can we start small?", "Yes. Start with the free 30-minute AI check. If your list is short and clean, we'll say so. If not, Essential covers the basics and you can move up as the work grows."],
  ["Who actually does the work?", "We do. Katarina on the legal side, Marino on implementation, both using AI tools we have verified ourselves. Everything you receive is made and checked by people."],
];

export const Faq = () => {
  const [openIndex, setOpenIndex] = useState(0);
  const toggle = (e, i) => {
    e.preventDefault();
    setOpenIndex((cur) => (cur === i ? -1 : i));
  };
  return (
    <section id="faq" className="section section--cream" aria-labelledby="faq-title" data-testid="faq-section">
      <div className="container faq__grid">
        <div className="stack faq__head" data-reveal>
          <p className="eyebrow">FAQ</p>
          <h2 id="faq-title" className="title title--compact">Questions we get on the first call.</h2>
        </div>
        <div className="faq__list" data-reveal>
          {FAQS.map(([q, a], i) => (
            <details className="faq__item" key={q} open={openIndex === i} data-testid={`faq-item-${i + 1}`}>
              <summary className="faq__q" onClick={(e) => toggle(e, i)} data-testid={`faq-question-${i + 1}`}>
                <span>{q}</span>
                <span className="faq__icon" aria-hidden="true">+</span>
              </summary>
              <p className="faq__a">{a}</p>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
};
